import BroadcastService from '@/integrations/pusher/BroadcastService';
import { BaseService } from '@/modules/core/app/services/abstracts/BaseService';
import { NotificationBroadcast } from '@/modules/notification/models/NotificationBroadcast';
import UserNotificationService from '@/modules/notification/services/UserNotificationService';
import { Channel as EchoChannel } from 'laravel-echo';

export class NotificationBroadcastBackgroundService extends BaseService {
  channel: EchoChannel | undefined = undefined;

  initialize(): void {
    if (this.channel) {
      BroadcastService.stopListeningForNotifications();
    }

    this.channel = BroadcastService.listenForNotifications((broadcast: NotificationBroadcast) =>
      UserNotificationService.onNewNotificationBroadcast(broadcast)
    );
  }
}

export default new NotificationBroadcastBackgroundService();
